
import { MapState } from "@/store/map/types";
import { ClusterContextMenuResponse, MarkerMetadata } from "@sureview/v2-mapping-saas";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

const MapStore = namespace("map");

@Component({})
export default class MapStackedItems extends Vue {
    @MapStore.State((state: MapState) => state.clusterContextMenuResponse)
    public readonly clusterContextMenuResponse: ClusterContextMenuResponse | null;

    @MapStore.Mutation protected setCloseInfoWindow: (close: boolean) => void;

    public readonly maxItemsToDisplay: number = 30;
    public searchTerm: string = "";

    /**
     * @summary Filters the markers from the response.
     */
	public get filteredMarkers(): MarkerMetadata[] {
        let markers: MarkerMetadata[] =
            this.clusterContextMenuResponse?.markers
                .filter((marker: MarkerMetadata) =>
                    marker.title.toLowerCase().includes(this.searchTerm.toLowerCase())) ?? [];

        if (markers.length > this.maxItemsToDisplay) {
            markers = markers.slice(0, this.maxItemsToDisplay);
        }

        return markers;
    }

    /**
     * @summary Initiates the 'onClick' for the marker.
     * @param {MarkerMetadata} marker The marker meta data.
     */
    public startClick(marker: MarkerMetadata): void {
        if (marker.onClick) {
            marker.onClick();
        }
    }
}
